import { faBell } from '@fortawesome/pro-solid-svg-icons';

import { Button } from '@growtherapy/sprout-ui';

import { Translate } from '../../i18n/Translate';
import { Toast } from '../../toasts/Toast';
import { ToastRenderFnProps } from '../../toasts/types';

export type SystemNotificationsPermissionSoftPromptProps = {
  /**
   * Called when the user clicks the button to request system notification
   * permissions.
   */
  onClick: () => void;
} & ToastRenderFnProps;

export function SystemNotificationsPermissionSoftPrompt({
  onClick,
  ...ariaProps
}: SystemNotificationsPermissionSoftPromptProps) {
  return (
    <Toast {...ariaProps} alignment='center' icon={faBell}>
      <Translate
        i18nKey='telehealth-core:notifications.clickToEnableSystemNotifications'
        components={{
          1: <Button onClick={onClick} className='p-0 m-0 font-normal text-neutral-900' use='link' />,
        }}
      />
    </Toast>
  );
}
